//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setInstoreThemeParams } from "../../features/instoreThemes/instoreThemesSlice";
import { SortingStateOption } from "../../models/sorting";
import { useTranslation } from "react-i18next";
import MainTableHeaderCell from "../_layout/MainTableHeaderCell";
//#endregion

export default function InstoreThemesTableHeader() {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { instoreTheme_params, loading } = useAppSelector(
    (state) => state.instoreThemes
  );
  //#endregion

  //#region LOGIC

  // Set order sorting
  const sortChangedHandler = (option: SortingStateOption) => {
    if (option.column !== null) {
      dispatch(
        setInstoreThemeParams({
          sort: JSON.stringify(option),
        })
      );
    } else {
      dispatch(setInstoreThemeParams({ sort: undefined }));
    }
  };

  //#endregion

  //#region RENDER
  return (
    <thead>
      <tr>
        {/* read */}
        <th
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs font-semibold text-gray-900"
          scope="col"
        />
        {/* name */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.name")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          sortName="name"
          disabled={loading}
          params={instoreTheme_params}
        />
        {/* Delete */}
        <th
          scope="col"
          className="whitespace-nowrap px-2 w-16 py-3.5 text-left text-xs font-semibold text-gray-900"
        />
      </tr>
    </thead>
  );
  //#endregion
}
